import { styled } from '../../../../core/theme/styled';

export const HeaderContainer = styled.div`
  margin-bottom: ${(props) => props.theme.sizes.xxsmall};
  border-top: 1px solid ${(props) => props.theme.configuration.strokeColor};
`;

export const StyledError = styled.div`
  color: ${(props) => props.theme.configuration.errorTextColor};
  font-size: ${(props) => props.theme.sizes.small};
  margin-bottom: ${(props) => props.theme.sizes.xxsmall};
`;

export const StyledUserHintId = styled.div`
  color: ${(props) => props.theme.palette.grey[600]};
  margin-top: -${(props) => props.theme.sizes.xxxsmall};
  margin-bottom: ${(props) => props.theme.sizes.small};
  font-size: ${(props) => props.theme.sizes.small};
`;
